export const GET_CREDIT_NOTES = "GET_CREDIT_NOTES"
export const GET_CREDIT_NOTES_SUCCESS = "GET_CREDIT_NOTES_SUCCESS"


export const SET_PARAMETERS = "SET_PARAMETERS"